import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { englishIqResultV2Schema } from '../schemasV2';

const englishIqHistoryEntryV2Schema = englishIqResultV2Schema.extend({
  comparability: z.enum(['comparable', 'first', 'too_soon', 'version_break']),
  improvement: z.number().int().nullable(),
});

const listEnglishIqHistoryV2DataSchema = z.object({
  benchmarks: z.array(englishIqHistoryEntryV2Schema),
  recommendedRetakeAt: z.number().int().nonnegative().nullable(),
  skills: z.object({
    grammar: z.array(englishIqHistoryEntryV2Schema),
    listening: z.array(englishIqHistoryEntryV2Schema),
    meaning: z.array(englishIqHistoryEntryV2Schema),
  }),
});

export type IListEnglishIqHistoryV2Data = z.infer<typeof listEnglishIqHistoryV2DataSchema>;

export const listEnglishIqHistoryV2ResponseSchema: z.ZodSchema<IAPI<IListEnglishIqHistoryV2Data>> =
  createApiResponseSchema(listEnglishIqHistoryV2DataSchema) as z.ZodSchema<
    IAPI<IListEnglishIqHistoryV2Data>
  >;

export type IListEnglishIqHistoryV2Response = IAPI<IListEnglishIqHistoryV2Data>;
